import { Box } from '@mui/material'
import { TableTitle } from '../Table.ui'
import SortIcon from '@mui/icons-material/Sort'
import NorthIcon from '@mui/icons-material/North'
import SouthIcon from '@mui/icons-material/South'
import { useState } from 'react'
import { TSortValue } from '../TableFilter/types'

interface Props {
  label: string
  sort: TSortValue
  handleSortState: any
  columnId: string
  sortable: boolean
}

const handleSortIcon = (sort) => {
  if (sort === 'asc') return NorthIcon
  if (sort === 'desc') return SouthIcon
  return SortIcon
}

export function TableSortTitle({
  label,
  sort,
  columnId,
  sortable,
  handleSortState,
}: Props) {
  const Icon = handleSortIcon(sort)

  const setSort = (sort) => {
    if (!sort) {
      handleSortState(columnId, 'asc')
    }
    if (sort === 'asc') {
      handleSortState(columnId, 'desc')
    }
    if (sort === 'desc') {
      handleSortState(columnId, null)
    }
  }

  return (
    <TableTitle onClick={() => sortable && setSort(sort)}>
      {label}
      {sortable ? <Icon fontSize="small" /> : null}
    </TableTitle>
  )
}
